export default __webpack_public_path__ + "static/collins_dev_resume-c076c945939b7190be8d48e403c3fe10.pdf";